import React, { FC } from 'react'

import { IconConnectedDevicesProps } from './IconConnectedDevices.types'
import * as Styled from './styles/IconConnectedDevices.style'

import { nonThemeableRules } from '../../ruleSet'

const IconConnectedDevices: FC<IconConnectedDevicesProps> = ({
  size = nonThemeableRules.defaultSize as number as IconConnectedDevicesProps['size'],
  isResponsive = false,
}: IconConnectedDevicesProps) => {
  return (
    <Styled.IconWrapper size={size} isResponsive={isResponsive}>
      <svg fill='none' viewBox='0 0 48 48' xmlns='http://www.w3.org/2000/svg'>
        <path d='M33.172 30.277H21.04' stroke='#0D0D0D' strokeLinecap='round' strokeLinejoin='round' strokeWidth='2' />
        <path d='M37.032 35.127h1.94m-27.107-.015h1.938' stroke='#E60000' strokeLinecap='round' strokeLinejoin='round' strokeWidth='2' />
        <path
          d='M36.157 21.063h6.69V36a3 3 0 0 1-3 3h-3.69a3 3 0 0 1-3-3V24.062a3 3 0 0 1 3-3v0ZM8.073 14.988h12.83v21.075a3 3 0 0 1-3 3h-9.83a3 3 0 0 1-3-3V17.986a3 3 0 0 1 3-3v0Z'
          stroke='#0D0D0D'
          strokeLinecap='round'
          strokeWidth='2'
        />
        <path d='M28.773 35.112h-7.87m4.109-4.315.008 3.83' stroke='#0D0D0D' strokeLinecap='round' strokeLinejoin='round' strokeWidth='2' />
        <path d='M41.038 21.063V7.012H11.25A4.25 4.25 0 0 0 7 11.262V15' stroke='#0D0D0D' strokeLinecap='round' strokeWidth='2' />
        <path d='M25 28a1 1 0 1 0 0-2 1 1 0 0 0 0 2Z' fill='#E60000' />
        <path
          d='M25.012 27.07a.038.038 0 1 0 0-.075.038.038 0 0 0 0 .075Z'
          stroke='#E60000'
          strokeLinecap='round'
          strokeLinejoin='round'
          strokeWidth='2'
        />
      </svg>
    </Styled.IconWrapper>
  )
}

export default IconConnectedDevices
